import {
  ADMIN_MY_PRODUCTS_ROOMS_DETAILS,
  ADMIN_MY_PRODUCTS_ROOMS_V2,
  TEMPLATES_DETAILS_V2,
  TEMPLATES_ROUTE_V2,
} from '../constants/routePathConstants';
import { Link, useSearchParams } from 'react-router-dom';
import { FAST_PREVIEW_TAG, MODEL_TYPES, RENDER_STATUS, RENDER_STATUS_OPTIONS } from '../constants/constants';
import { Mixpanel, MxEvent } from './Mixpanel';
import { checkIfMemberHaveEditorAccess, useUserContext } from '../contexts/UserContext';
import { LIVE_FURNISH } from '../constants/projectConstants';
import { RENDER_IMAGE_TYPE } from '../constants/renderPreviewConstants';
import ThumbnailCardUI from './ThumbnailCardUI';
import ThumbnailCardV2 from './ThumbnailCardV2';
import { dispatcher } from '../helpers/projectHelper';
import { getCuratorRoomPath } from '../helpers/urlHelper';
import { getDownloadAndCollect3DFileAction } from '../helpers/jsHelper';
import { icons } from '../assets';
import { paginatedRoomsActions } from '../redux/slicers/admin/paginatedRooms';
import { setTemporaryPreventBackupPopup } from '../redux/slicers/admin/curatorSlicer';
import { useTemplateActions } from '../hooks/useTemplateActions';
import { PERMISSION } from '../constants/permissionConstants';
import { useStaticPermissions } from '../hooks/usePermissions';

const { InfoIcon } = icons;

export const ThumbnailCardTemplate = ({
  data,
  size,
  fullWidth,
  onSelect,
  selected,
  to = TEMPLATES_DETAILS_V2,
  hideFavourite,
  onEdit,
  onEditInfo,
  modelType = MODEL_TYPES.TEMPLATES,
  curatorProp,
  designV2,
  showMenu,
  redirect,
  ...rest
}) => {
  const [params] = useSearchParams();

  const {
    favouriteLoading,
    onFavouriteToggle,
    onShare,
    addToCollection,
    onEditInfo: _onEditInfo,
    requestTo3DFilesCollection,
    download3DFilesZip,
  } = useTemplateActions({
    item: data,
  });

  const { canAccessLiveOnAppData, isGuestUser, isEditor, canDownload3DFile } = useUserContext();
  const {hasPermission} = useStaticPermissions()
  const isTemplate = modelType === MODEL_TYPES.TEMPLATES;

  const cameraName = data?.images?.[0]?.cameraName;
  const url = getCuratorRoomPath(data.id, {
    cameraName: cameraName,
    propId: curatorProp,
  });
  const secondLine =
    (data?.owner_organization_details?.id !== LIVE_FURNISH.id &&
      data?.owner_organization_details?.name) ||
    '';

  // to remove the member details from the card if the rooms are created from LOA
  const tempData = Object.assign({}, data);
  tempData.member_details = {};
  const updatedData = isTemplate && canAccessLiveOnAppData() && data?.is_custom ? data : tempData;

  const isFilmicImgType = data?.img_type === RENDER_IMAGE_TYPE.FILMIC;
  const updatedImages = data?.images?.map((a) => {
    if (isFilmicImgType) {
      return {
        ...a,
        thumbnail: a?.filmic_thumbnail || a?.thumbnail,
      };
    }
    return {
      ...a,
      thumbnail: a?.thumbnail,
    };
  });

  const handleEditInfo = onEditInfo || _onEditInfo;

  // showing camera angle thumbnail for live on app room
  const thumbnail = data?.is_custom
    ? isFilmicImgType
      ? data?.images?.[0]?.filmic_thumbnail
      : data?.images?.[0]?.thumbnail || data?.thumbnail
    : data?.thumbnail;

  const preventCuratorBackupOpen = () => {
    dispatcher(
      setTemporaryPreventBackupPopup({
        type: 'room',
        id: data.id,
      })
    );
  };
  const handleMixPanelOpenProject = (Project_opened_from) => {

    Mixpanel.track(true, MxEvent.EDIT_IN_3D_TEMPLATE, {
      template_id: data?.id,
      template_name: data?.name,
      template_angle_name: '',
    });

    Mixpanel.track(true, MxEvent.CURATOR_STARTED, {
      'Curator project type': 'template',
      'Curator opened from': Project_opened_from,
      'Room id': data?.id,
      'Room name': data?.name,
      'Room isFavourite': data?.is_favourite,
      'Room creator id': data?.member_details?.id,
      'Room creator name': data?.member_details?.name,
      'Room creator email': data?.member_details?.email,
      'Room created at': data?.created_at,
    });
  };
  const handleEdit = () => {
    if (!checkIfMemberHaveEditorAccess()) return;

    if (onEdit) {
      onEdit?.();
    } else {
      handleMixPanelOpenProject('Edit button on template thumbnail');
      handleOpenCurator();
      window.open(url, '_blank');
    }
  };

  const handleEditWithFastPreview = () => {
    if (!checkIfMemberHaveEditorAccess()) return;

    let _url = url + `&${FAST_PREVIEW_TAG}=true`

    handleMixPanelOpenProject('Edit with  fast preview button on template thumbnail');
    handleOpenCurator();
    window.open(_url, '_blank');
  };

  to = to + `?${params}`;

  let LOA_Status = null;
  if (data?.is_custom) {
    const s = RENDER_STATUS_OPTIONS.find((a) => a.value === data?.status);
    if (s && s.value !== RENDER_STATUS.STATUS_NOT_DONE && s.value !== RENDER_STATUS.STATUS_DONE) {
      LOA_Status = s;
    }
  }

  const handleOpenCurator = () => {
    preventCuratorBackupOpen();
  };

  const titleProps = !redirect ? null: {
    as: Link,
    target: '_blank',
    to: url,
    onClick: (e) => {
      if (!checkIfMemberHaveEditorAccess()) {
        e.preventDefault();
        return;
      }
      handleMixPanelOpenProject('Title of template thumbnail');
      handleOpenCurator();
    },
  };

  if (canDownload3DFile && modelType === MODEL_TYPES.TEMPLATES) {
    // generating download & collect 3d files
    rest.customActions = getDownloadAndCollect3DFileAction({
      actions: rest.customActions,
      data,
      rest,
      designV2,
      download3DFilesZip,
      requestTo3DFilesCollection,
      onUpdate: (updatedData) => dispatcher(paginatedRoomsActions.update(updatedData)),
    });
  }

  return designV2 ? (
    <ThumbnailCardV2
      onFavouriteChange={onFavouriteToggle(data)}
      onSelect={onSelect}
      selected={selected}
      isFavourite={data.is_favourite}
      hideFavourite={hideFavourite}
      favouriteLoading={favouriteLoading}
      titleProps={titleProps}
      data={data}
      id={data?.id}
      name={data?.name}
      thumbnail={data?.thumbnail || updatedImages?.[0]?.thumbnail}
      images={updatedImages}
      date={
        isTemplate && canAccessLiveOnAppData() && data?.is_custom ? data?.created_at : undefined
      }
      userCard
      showMenu={showMenu}
      showCheckbox
      isFavouriteIcon
      onEdit={handleEdit}
      onEditWithFastPreview={(isGuestUser() || hasPermission(PERMISSION.CAN_USE_FAST_PREVIEW)) ? handleEditWithFastPreview : null}
      savePreviousRoute
      onEditInfo={isEditor ? handleEditInfo : null}
      onShare={onShare}
      onAddToCollection={addToCollection}
      redirect={redirect}
      redirectURL={`${isTemplate ? TEMPLATES_ROUTE_V2 : ADMIN_MY_PRODUCTS_ROOMS_V2}/${data?.id}`}
      redirectTarget="_self"
      secondLine={canAccessLiveOnAppData() && data?.is_custom ? '' : secondLine}
      {...rest}
    />
  ) : (
    <ThumbnailCardUI
      key={data.id}
      id={data.id}
      onEdit={handleEdit}
      onEditWithFastPreview={(isGuestUser() || hasPermission(PERMISSION.CAN_USE_FAST_PREVIEW)) ? handleEditWithFastPreview : null}
      onEditInfo={isEditor ? handleEditInfo : null}
      to={getTo(to, curatorProp)}
      thumbnail={thumbnail}
      images={updatedImages}
      name={data.name}
      isFavourite={data.is_favourite}
      favouriteLoading={favouriteLoading}
      date={
        isTemplate && canAccessLiveOnAppData() && data?.is_custom ? data?.created_at : undefined
      }
      onShare={onShare}
      onFavouriteChange={onFavouriteToggle(data)}
      size={size}
      titleProps={titleProps}
      fullWidth={fullWidth}
      onSelect={onSelect}
      selected={selected}
      onAddToCollection={addToCollection}
      hideFavourite={hideFavourite}
      data={updatedData}
      secondLine={canAccessLiveOnAppData() && data?.is_custom ? '' : secondLine}
      overlayText={LOA_Status}
      {...rest}
    />
  );
};

export const ThumbnailCardRoom = (props) => {
  return (
    <ThumbnailCardTemplate
      {...props}
      savePreviousRoute
      to={props.to || ADMIN_MY_PRODUCTS_ROOMS_DETAILS}
      modelType={MODEL_TYPES.ROOM}
    />
  );
};

const getTo = (to, curatorProp) => {
  if (!to) return undefined;

  if (!curatorProp) return to;

  const query = `curatorProp=${curatorProp}`;

  let uto = to;
  if (window.location.search) {
    uto = `${uto}&${query}`;
  } else {
    uto = `${uto}${query}`;
  }

  return uto;
};
